import { Injectable } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";


@Injectable({
  providedIn: 'root'
})
export class TranslationInitService {
  constructor(private translate: TranslateService) {}

  initTranslation(): Promise<void> {
    const defaultLang = 'ua';
    this.translate.setDefaultLang(defaultLang);
    return this.translate.use(defaultLang).toPromise().then(() => undefined);
  }
}
